import { nonEmpty } from "../nonEmpty";
import { toText } from "../toText";
import type { QuickCartItem } from "./quickCartGrouping";

// Позиция «Быстрой корзины» из строки журнала заказов (`eplex/orders/journal`).
// Одна и та же строка читается и списком корзины, и наблюдателем за оформлением
// (CAB-782) — поэтому разбор вынесен из стора в чистую функцию.

/** add_info: {"e0Vin":"...","e0PlateNumber":"..."} — запасной источник VIN/госномера. */
export function parseQuickCartAddInfo(raw: unknown): { vin: string | null; plate: string | null } {
  if (typeof raw !== "string" || !raw) return { vin: null, plate: null };
  try {
    const parsed = JSON.parse(raw) as { e0Vin?: string; e0PlateNumber?: string };
    return { vin: nonEmpty(parsed.e0Vin) ?? null, plate: nonEmpty(parsed.e0PlateNumber) ?? null };
  } catch {
    return { vin: null, plate: null };
  }
}

function textOrNull(value: unknown): string | null {
  return typeof value === "string" && value ? value : null;
}

export function mapQuickCartItem(row: Record<string, unknown>): QuickCartItem {
  const addInfo = parseQuickCartAddInfo(row.add_info);
  return {
    thash: toText(row.thash ?? row.hash_key),
    vin: textOrNull(row.vin) ?? addInfo.vin,
    plate: textOrNull(row.plate_number) ?? addInfo.plate,
    name: typeof row.name === "string" ? row.name : "",
    brand: typeof row.brand === "string" ? row.brand : "",
    article: typeof row.article === "string" ? row.article : "",
    cost: Number(row.cost) || 0,
    qty: Number(row.qty) || 1,
    count: toText(row.count),
    timeInt: row.time_int == null ? null : Number(row.time_int),
    pluginId: Number(row.plugin_id) || 0,
    sreqid: typeof row.sreqid === "string" ? row.sreqid : "",
    posIdx: row.pos_idx == null ? null : Number(row.pos_idx),
  };
}
